import { render, staticRenderFns } from "./detailIndex.vue?vue&type=template&id=4da853dd&"
import script from "./detailIndex.vue?vue&type=script&lang=js&"
export * from "./detailIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports